import { render, staticRenderFns } from "./indexWorkEdit.vue?vue&type=template&id=a557f548&"
import script from "./indexWorkEdit.vue?vue&type=script&lang=ts&"
export * from "./indexWorkEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports